<template>
  <div>
    <nav v-if="!isNew" class="breadcrumb is-small" aria-label="breadcrumbs">
      <ul>
        <li>
          <router-link to="/call-histories">
            一覧
          </router-link>
        </li>
        <li class="is-active">
          <a href="#" aria-current="page">通話履歴編集</a>
        </li>
      </ul>
    </nav>

    <h1 v-if="isNew" class="title is-4 is-spaced">
      通話履歴 新規登録
    </h1>
    <h1 v-else class="title is-4 is-spaced">
      通話履歴 編集
    </h1>
    <div class="column">
      <div class="field is-horizontal">
        <div class="field-label">
          <!--  Construction owner name -->
          <label class="label">施工主名</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              {{ company_name }}
            </div>
            <input v-model="company_id" type="hidden">
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">日時</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <datetime
                v-model="call_dt"
                type="datetime"
                input-class="input"
                zone="Asia/Tokyo"
                format="yyyy-MM-dd HH:mm"
                :phrases="{ok: '設定', cancel: '閉じる'}"
                :minute-step="5"
                :week-start="7"
                auto
              />
            </div>
            <p v-if="errors.call_dt" class="help is-danger">
              {{ errors.call_dt }}
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label">
          <!-- Manager/Person incharge -->
          <label class="label">担当者</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <b-select v-model="shop_id" required>
                <option v-for="shop in shops" :key="shop.shop_id" :value="shop.shop_id">
                  {{ shop.charge }}
                </option>
              </b-select>
            </div>
            <p v-if="errors.shop" class="help is-danger">
              {{ errors.shop }}
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label">
          <!-- Telephone number -->
          <label class="label">電話番号</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div v-if="isNew && shop_id" class="control">
              <b-select v-model="phone_number" required>
                <option v-if="!phone_numbers[shop_id]" :value="null">
                  電話番号が登録されていません
                </option>
                <option v-for="number in phone_numbers[shop_id]" :key="number.phone_number"
                        :value="number.phone_number"
                >
                  {{ number.phone_number | tel }}
                </option>
              </b-select>
            </div>
            <div v-else-if="isNew" class="control">
              <b-select v-model="phone_number" required placeholder="電話番号を選択してください" disabled />
            </div>
            <div v-else class="control">
              <b-input v-model="phone_number" required />
            </div>
            <p v-if="errors.phone_number" class="help is-danger">
              {{ errors.phone_number }}
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">通話内容</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <b-input v-model="call_content" custom-class="large_textarea" type="textarea" maxlength="999" />
            </div>
            <p v-if="errors.call_content" class="help is-danger">
              {{ errors.call_content }}
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">状態</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <b-select v-model="state">
                <option v-for="(value,key) in states" :key="key" :value="key">
                  {{ value }}
                </option>
              </b-select>
            </div>
            <p v-if="errors.state" class="help is-danger">
              {{ errors.state }}
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">見込み</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <b-select v-model="likelihood">
                <option v-for="(value,key) in likelihoods" :key="key" :value="key">
                  {{ value }}
                </option>
              </b-select>
            </div>
            <p v-if="errors.likelihood" class="help is-danger">
              {{ errors.likelihood }}
            </p>
          </div>
        </div>
      </div>

      <div class="control has-text-centered">
        <button type="button" class="button is-primary" @click="register">
          登録
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {Datetime} from 'vue-datetime'

export default {
  name: 'CallHistoriesRegister',
  components: {
    datetime: Datetime,
  },
  data() {
    return {
      call_id: null,
      company_id: null,
      isNew: null,
      errors: {},
      company_name: null,
      shops: [
        {
          shop_id: null,
          shop_name: null,
        }],
      shop_id: null,
      call_dt: new Date().toISOString(),
      phone_number: null,
      call_content: null,
      state: 10,
      likelihood: 10,
      phone_numbers: [],
      states: [],
      likelihoods: [],
    }
  },

  watch: {
    '$route'() {
      this.setData()
    },
  },
  mounted() {
    this.setData()
  },
  methods: {
    setData() {
      this.setInit()
      this.company_id = Number(this.$route.params.company_id)
      if (this.$route.params.call_id === 'new') {
        this.isNew = true
      } else {
        this.isNew = false
        this.call_id = Number(this.$route.params.call_id)
      }
      this.getCallHistory()
    },
    setInit() {
      this.company_id = null
      this.company_name = null
      this.shops = [
        {
          shop_id: null,
          shop_name: null,
        }]
      this.call_dt = new Date().toISOString()
      this.phone_number_id = null
      this.phone_number = null
      this.call_content = null
      this.state = 10
      this.errors = {}
    },
    getCallHistory() {
      this.$http.get('/call-histories/' + this.$route.params.call_id + '/register/' + this.company_id).
          then(response => {
            console.log('response', response.data)
            this.states = response.data.states
            this.likelihoods = response.data.likelihoods
            this.company_name = response.data.company_name
            this.shops = response.data.shops
            if (this.isNew) {
              this.phone_numbers = response.data.phone_numbers
            } else {
              if (response.data.call_history.call_dt === null) {
                this.call_dt = null
              } else {
                this.call_dt = moment(response.data.call_history.call_dt).toISOString()
              }
              this.shop_id = response.data.call_history.shop_id
              this.phone_number = response.data.call_history.phone_number
              this.call_content = response.data.call_history.call_content
              this.state = response.data.call_history.state
              this.likelihood = response.data.call_history.likelihood
            }
          })
    },
    register() {
      this.errors = {}
      let call_id = this.call_id || 'new'

      if (!this.call_dt) {
        this.errors.call_dt = '日時を入力してください。'
      }

      if (!this.shop_id) {
        this.errors.shop = '担当者を選択してください'
      }

      if (this.isNew && !this.phone_number) {
        this.errors.phone_number = '電話番号を選択してください。'
      }

      if (!this.isNew && !this.phone_number) {
        this.errors.phone_number = '電話番号を入力してください。'
      }

      if (Object.keys(this.errors).length > 0) {
        return
      }

      this.openLoading()
      this.$http.post('/call-histories/' + call_id + '/register', {
        shop_id: this.shop_id,
        call_dt: this.call_dt,
        phone_number: this.phone_number,
        call_content: this.call_content,
        state: this.state,
        likelihood: this.likelihood,
      }).then(() => {
        this.closeLoading()
        this.$buefy.toast.open(`登録が完了しました`)
        this.$router.push({name: 'CompaniesDetail', params: {company_id: this.company_id}})
      }).catch(error => {
        console.log(error)
        this.closeLoading()
      })
    },
  },
}
</script>

<style lang="scss">
.large_textarea {
  min-height: 260px !important;
}
</style>
